import styled from 'styled-components';
import * as colors from '~/config/colors';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.1rem;
  width: 55rem;

  

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  } 
  

  @media (max-width: 768px) {
    width: 100%;
  }

  .Container__liberacao_cabecalho {       
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1.1rem; 
    
    padding: 1.5rem;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);  

    input {
        height: 1rem;  
        font-size: 1.5rem;       
        color : ${colors.CAMPO_INFORMACAO_TEXTO};
        font-weight: 300;
        letter-spacing: 1px;
        //font-family:  'verdana, sans-serif';
        text-align: left;
        text-transform: uppercase;
        background:  ${colors.CAMPO_INFORMACAO_BACKGROUND};      
    }

      p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  } 
  }

  .Container__liberacao {            
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1.1rem; 

    padding: 1.5rem;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);  

    input {
        height: 1rem;  
        font-size: 2rem;      
        
        color : ${colors.CAMPO_INFORMACAO_TEXTO};
        font-weight: 900;
        letter-spacing: 1px;
        font-family:  'verdana, sans-serif';
        text-align: center;
        background:  ${colors.CAMPO_INFORMACAO_BACKGROUND};          
    }

     p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  } 
  }

 
`;

